import { createFileRoute, redirect } from "@tanstack/react-router";

/** Public-contract invoice create replaces the old contract create flow. */
export const Route = createFileRoute("/vendor/contract/create")({
	beforeLoad: () => {
		throw redirect({ to: "/vendor/invoices/create" });
	}
});
